import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidatorFn } from '@angular/forms';
import { Question } from '../../services/generated/models';

export function minmaxValidator(minValue: string, maxValue: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const min = +minValue;
    const max = +maxValue;
    if (minValue === '' && maxValue === '') {
      return null;
    }

    if (minValue === '') {      // Als min value niets bevat is het null, dus geen ondergrens
      return +control.value <= max ? null : { 'minmaxValidator': { value: control.value } };
    }

    if (maxValue === '') {      // Als max value niets bevat is het null, dus geen bovengrens
      return +control.value >= min ? null : { 'minmaxValidator': { value: control.value } };
    }

    // Als we hier komen hebben we een onder en bovengrens
    return +control.value >= min && +control.value <= max ? null : { 'minmaxValidator': { value: control.value } };
  };
}


@Directive({
  selector: '[minmaxValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MinmaxvalidatorDirective, multi: true }]
})
export class MinmaxvalidatorDirective implements Validator {

  @Input() minValidator: string;
  @Input() maxValidator: string;

  validate(c: AbstractControl): { [key: string]: any; } {
    return minmaxValidator(this.minValidator, this.maxValidator)(c);
  }

  constructor() { }

}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/Validators/minmaxvalidator.directive.ts